class VariantSelectCart extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }
  
    onVariantChange(event) {
      console.log("e", event);
      this.updateOptions();
      this.updateMasterId();
      this.updateVariantStatuses();
  
      if (!this.currentVariant) {
  
      } else {
        this.updateVariantInput();
        this.renderProductInfo();
      }
    }
  
    renderProductInfo() {
     
      const addButtonUpdated = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
      const parent           = addButtonUpdated.closest('.cart-drawer__container-side');
      
      //console.log("cc", addButtonUpdated);

      if (this.currentVariant.available) {
        let label = 'ADD TO CART';
        if( parent ){
          label = "ADD";
        }
        addButtonUpdated.removeAttribute('disabled');
        addButtonUpdated.querySelector('span').innerText = label;
        return
      }
      addButtonUpdated.querySelector('span').innerText = "SOLD OUT";
      addButtonUpdated.setAttribute('disabled', true);
    }
  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
        if (element.tagName === 'SELECT') {
          return element.value;
        }
        if (element.tagName === 'FIELDSET') {
          return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
        }
      });
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
  
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      );
  
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    updateVariantStatuses() {
      const selectedOptionOneVariants = this.variantData.filter(
        (variant) => this.querySelector(':checked').value === variant.option1
      );
      const inputWrappers = [...this.querySelectorAll('.product-form__input')];
      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants
          .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
          .map((variantOption) => variantOption[`option${index + 1}`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue);
      });
    }
  
    setInputAvailability(elementList, availableValuesList) {
      elementList.forEach((element) => {
  
        let value = element.getAttribute('value');
  
        const availableElement = availableValuesList.includes(value);
  
        if (element.tagName === 'INPUT') {
          element.classList.toggle('disabled', !availableElement);
        } else if (element.tagName === 'OPTION') {
  
          if (availableElement) {
            element.removeAttribute('disabled');
            return
          }
          element.setAttribute('disabled', true);
          element.removeAttribute('selected');
  
        }
      });
    }
  
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      console.log(this.variantData);
      
      return this.variantData;
    }
  }
  
  customElements.define('variant-selects-cart', VariantSelectCart);